import { createFileRoute } from "@tanstack/react-router";
import { ForProfessionalsComponent } from "@/pages/for-professionals";
import { head, loader } from "@/pages/for-professionals.meta";

export const Route = createFileRoute("/$locale/for-professionals")({
  loader,
  head,
  component: ForProfessionalsComponent,
});
